/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Add_ShortInputs */

const en_plan_add_short = /** @type {(inputs: Plan_Add_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cook`)
};

const de_plan_add_short = /** @type {(inputs: Plan_Add_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochen`)
};

/**
* | output |
* | --- |
* | "Cook" |
*
* @param {Plan_Add_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_add_short = /** @type {((inputs?: Plan_Add_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Add_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_add_short(inputs)
	return en_plan_add_short(inputs)
});